const AccountingIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        fill="none"
        viewBox="0 0 60 60"
        {...props}>
        <>
            <path
                fill="currentColor"
                d="M56,11H41V7h2c0.6,0,1-0.4,1-1V2c0-0.6-0.4-1-1-1H17c-0.6,0-1,0.4-1,1v4c0,0.6,0.4,1,1,1h2v4H4c-2.2,0-4,1.8-4,4v15
			c0,0.6,0.4,1,1,1h3v27c0,0.6,0.4,1,1,1h33v-2H6V31h14v-2H5H2V15c0-1.1,0.9-2,2-2h16h20h16c1.1,0,2,0.9,2,2v14h-3H40v2h14v2h2v-2h3
			c0.6,0,1-0.4,1-1V15C60,12.8,58.2,11,56,11z M18,3h24v2H18V3z M21,11V7h18v4H21z"/>
            <path
                fill="currentColor"
                d="M37,26H23c-0.6,0-1,0.4-1,1v6c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1v-6C38,26.4,37.6,26,37,26z M36,32H24v-4h12V32z"/>
            <path
                fill="currentColor"
                d="M59,35H41c-0.6,0-1,0.4-1,1v22c0,0.6,0.4,1,1,1h18c0.6,0,1-0.4,1-1V36C60,35.4,59.6,35,59,35z M58,37v4H42v-4H58z M42,57
			V43h16v14H42z"/>
            <rect x="45" y="45" width="2" height="2"/>
            <rect x="49" y="45" width="2" height="2"/>
            <rect x="53" y="45" width="2" height="2"/>
            <rect x="45" y="49" width="2" height="2"/>
            <rect x="49" y="49" width="2" height="2"/>
            <rect x="53" y="49" width="2" height="2"/>
            <rect x="45" y="53" width="2" height="2"/>
            <rect x="49" y="53" width="2" height="2"/>
            <rect x="53" y="53" width="2" height="2"/>
            <rect x="43" y="38" width="2" height="2"/>
            <rect x="46" y="38" width="2" height="2"/>
            <rect x="49" y="38" width="2" height="2"/>
            <rect x="52" y="38" width="2" height="2"/>
            <rect x="55" y="38" width="2" height="2"/>
        </>
        {/*<path*/}
        {/*    fill="currentColor"*/}
        {/*    d="M12 22c5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10Z"*/}
        {/*    opacity={0.12}*/}
        {/*/>*/}
        {/*<path*/}
        {/*    stroke="currentColor"*/}
        {/*    strokeLinecap="round"*/}
        {/*    strokeLinejoin="round"*/}
        {/*    strokeWidth={2}*/}
        {/*    d="M9.5 7.5h4.25C14.9926 7.5 16 8.5074 16 9.75S14.9926 12 13.75 12H9.5h4.75c1.2426 0 2.25 1.0074 2.25 2.25s-1.0074 2.25-2.25 2.25H9.5m0-9H8m1.5 0v9m0 0H8M10 6v1.5m0 9V18m3-12v1.5m0 9V18m9-6c0 5.5228-4.4772 10-10 10-5.5229 0-10-4.4772-10-10C2 6.4771 6.4771 2 12 2c5.5228 0 10 4.4771 10 10Z"*/}
        {/*/>*/}
    </svg>
);

export default AccountingIcon;
